import React from "react"
import styled from "@emotion/styled"

const ParallaxContainer = styled.div`
  position: relative;
  overflow: hidden;
`

export default ParallaxContainer
